import { render, staticRenderFns } from "./AddSurveyCard.vue?vue&type=template&id=4981101a&scoped=true"
import script from "./AddSurveyCard.vue?vue&type=script&lang=js"
export * from "./AddSurveyCard.vue?vue&type=script&lang=js"
import style0 from "./AddSurveyCard.vue?vue&type=style&index=0&id=4981101a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4981101a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4981101a')) {
      api.createRecord('4981101a', component.options)
    } else {
      api.reload('4981101a', component.options)
    }
    module.hot.accept("./AddSurveyCard.vue?vue&type=template&id=4981101a&scoped=true", function () {
      api.rerender('4981101a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/List/NoData/AddSurveyCard.vue"
export default component.exports